export default __webpack_public_path__ + "static/media/feedback-success.4566f2e2.svg";